import { gql } from '@apollo/client'
import { ApostleLiteFragment } from '@src/graphql/fragment/apostle'
import { PageInfoFragment } from '@src/graphql/fragment/pageInfo'

export default gql`
  query GetApostles(
    $filterInput: ApostlesFilterInput!
    $sortInput: ApostleSortInput!
    $pagingInput: PagingInput
  ) {
    getApostles(
      filterInput: $filterInput
      sortInput: $sortInput
      pagingInput: $pagingInput
    ) {
      edges {
        cursor
        node {
          ...ApostleLite
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${ApostleLiteFragment}
  ${PageInfoFragment}
`
